import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './Faq.css';

const faqs = [
  {
    question: "Why isn't there a compiled .exe file?",
    answer: "I have explicitly dropped support for standalone compiled .exe files. Interacting with the deep Windows Audio Session APIs requires careful memory and COM thread management. Compiling this program into an executable introduces opaque threading states and hides error streams, leading to unpredictable crashes that simply don't exist when interpreting the code naturally."
  },
  {
    question: "Are there memory leaks?",
    answer: "No. The utility is optimized for efficiency. By utilizing garbage collection techniques and safely resetting Windows COM pointers every 5 minutes, it will never build up memory leaks, even if left running for months."
  },
  {
    question: "How do I ignore certain applications like Discord?",
    answer: "You can easily customize this! Within the utility's GUI, there is a capability to explicitly define which programs the audio-monitor should ignore, preventing false positives from apps like Discord or OBS."
  }
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="faq container">
      <div className="faq-header">
        <h2>Technical FAQ</h2>
        <p>Common questions about how StopSpoti works.</p>
      </div>

      <div className="faq-accordion">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            <div className="faq-question">
              <h3>{faq.question}</h3>
              <ChevronDown className="chevron" />
            </div>
            <div className="faq-answer">
              <div className="answer-content">
                <p>{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
